import ApiBaseService from "services/ApiBaseService.js";

class OrganizationService {
  static getOrganizationHospitals() {
    return ApiBaseService.request(`/organizations/hospitals`, "GET", null);
  }

  static getHospitalStats([hospitalId]) {
    return ApiBaseService.request(
      `/organizations/hospital/${hospitalId}/stats`,
      "GET",
      null
    );
  }

  static getHospitalDoctors([hospitalId]) {
    return ApiBaseService.request(
      `/organizations/hospital/${hospitalId}/doctors`,
      "GET",
      null
    );
  }

  static getActiveOrganizations() {
    return ApiBaseService.request(
      `/organizations/active`,
      "GET",
      null
    );
  }

  static getHospitalsByOrganization([organizationId]) {
    return ApiBaseService.request(
      `/organizations/${organizationId}/hospitals`,
      "GET",
      null
    );
  }
}

export default OrganizationService;
